import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import { ApplicationState } from "../../../store/ApplicationState";
import { getDisciplineDetails } from "../../../actions/Authorization";
import DisciplineServiceDetails from "../Components/DisciplineServiceDetails";
import { DisciplineDetailsDispatchTypes } from "../../../models/DispatchTypes/DesciplineDetails";

const mapStateToProps = ({ disciplineDetailsState }: ApplicationState) => ({
    disciplineDetailsData: disciplineDetailsState,
});

type DispatchTypes = DisciplineDetailsDispatchTypes;

const mapDispatchToProps = (
  dispatch: ThunkDispatch<
    ApplicationState,
    Record<string, never>,
    DispatchTypes
  >
) => {
  return {
    getDisciplineDetails: (serviceRequestDisciplineId: number) => {
      dispatch(getDisciplineDetails(serviceRequestDisciplineId));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(DisciplineServiceDetails);
